import Reveal from "@/components/base/Reveal";
import SectionLabel from "@/components/base/SectionLabel";
import { useInView } from "@/hooks/useInView";

const steps = [
  {
    number: "01",
    icon: "ri-search-eye-line",
    title: "Seleção de produtos",
    description: "Identificação de produtos alinhados às necessidades e oportunidades do mercado brasileiro.",
  },
  {
    number: "02",
    icon: "ri-ship-2-line",
    title: "Importação",
    description: "Produtos de origem internacional incorporados ao portfólio da empresa.",
  },
  {
    number: "03",
    icon: "ri-store-2-line",
    title: "Comercialização",
    description: "Atuação comercial com empresas de diferentes segmentos.",
  },
  {
    number: "04",
    icon: "ri-road-map-line",
    title: "Distribuição nacional",
    description: "Produtos disponibilizados para o mercado brasileiro.",
  },
];

export default function BusinessFlow() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section id="atuacao" className="relative bg-background-50 py-16 md:py-20 lg:py-24">
      <span
        className="pointer-events-none absolute inset-x-0 top-0 mx-auto h-px w-2/3 bg-gradient-to-r from-transparent via-accent-500/25 to-transparent"
        aria-hidden="true"
      />

      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-12">
        <Reveal className="max-w-2xl">
          <SectionLabel>Nossa atuação</SectionLabel>
          <h2 className="mt-5 font-heading text-3xl font-medium leading-[1.15] text-foreground-950 md:text-5xl">
            Da identificação de oportunidades à comercialização no mercado nacional.
          </h2>
        </Reveal>

        <div ref={ref} className="relative mt-14 md:mt-16">
          <div
            className={`pointer-events-none absolute left-0 right-0 top-6 hidden h-px origin-left bg-gradient-to-r from-accent-400/0 via-accent-400/60 to-accent-400/0 transition-transform duration-[1400ms] ease-editorial lg:block ${
              inView ? "scale-x-100" : "scale-x-0"
            }`}
            aria-hidden="true"
          />

          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
            {steps.map((step, index) => (
              <Reveal key={step.number} delay={index * 120} className="group relative">
                <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-accent-400/50 bg-background-50 transition-all duration-500 group-hover:border-accent-500 group-hover:bg-accent-50">
                  <i className={`${step.icon} text-xl text-accent-600`}></i>
                  <span className="pointer-events-none absolute inset-0 rounded-full ring-1 ring-accent-400/0 transition-all duration-700 group-hover:ring-4 group-hover:ring-accent-400/15" />
                </div>
                <p className="mt-6 font-heading text-2xl font-medium text-accent-600 md:text-3xl">{step.number}</p>
                <span className="mt-4 block h-px w-10 bg-accent-500/70 transition-all duration-500 group-hover:w-16" />
                <h3 className="mt-4 font-heading text-xl font-medium text-foreground-950 md:text-2xl">
                  {step.title}
                </h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground-600">{step.description}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}